import {isNullOrUndefined} from 'util';
import {FormGroup} from '@angular/forms';
import {Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {FormUtils} from '../../../../../common/utils';
import {FilterFieldClearDirective} from '../filter-field-clear.directive';
import {AbstractFilterComponent} from './abstract.filter.component';

@Component({
    selector: 'tfl-callback-based-filter',
    template: require('./filter.template.html')
})
export class FilterCallbackBasedComponent extends AbstractFilterComponent {

    @Input('form') form: FormGroup;
    @Input('columns') columns: number = 3;
    @Input('verticalAlignment') verticalAlignment: boolean = false;

    @Output() onSearch: EventEmitter<any> = new EventEmitter();

    @ContentChildren(FilterFieldClearDirective) filterFieldComponents: QueryList<FilterFieldClearDirective>;

    submit(event, form) {
        if (FormUtils.isValid(form)) {
            this.onSearch.emit(form.value);
        }
    }

    reset() {
        let values = {};
        if (!isNullOrUndefined(this.filterFieldComponents)) {
            this.filterFieldComponents.forEach(field => {
                values = {...values, [field.controlName]: field.defValue};
                field.reset();
            });
        }

        this.onSearch.emit(values);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/container/filter.callback-based.component.ts